var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloatingHeading3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heading"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6012)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.5C4 5.22386 3.77614 5 3.5 5C3.22386 5 3 5.22386 3 5.5V14.5C3 14.7761 3.22386 15 3.5 15C3.77614 15 4 14.7761 4 14.5V10.5H10V14.5C10 14.7761 10.2239 15 10.5 15C10.7761 15 11 14.7761 11 14.5V5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V9.5H4V5.5ZM13.5 8C13.2239 8 13 8.22386 13 8.5C13 8.77614 13.2239 9 13.5 9H15.5397L14.3404 10.7133C14.2335 10.866 14.2204 11.0655 14.3065 11.2309C14.3926 11.3963 14.5635 11.5 14.75 11.5C14.9555 11.5 15.1579 11.5507 15.3392 11.6476C15.5205 11.7445 15.675 11.8847 15.7892 12.0556C15.9034 12.2265 15.9737 12.4229 15.9939 12.6275C16.014 12.8321 15.9834 13.0385 15.9047 13.2284C15.8261 13.4183 15.7018 13.5859 15.5429 13.7163C15.384 13.8467 15.1954 13.9359 14.9938 13.976C14.7922 14.0161 14.5838 14.0059 14.3871 13.9462C14.1904 13.8865 14.0114 13.7793 13.866 13.6339C13.6708 13.4387 13.3542 13.4387 13.1589 13.634C12.9637 13.8292 12.9637 14.1458 13.159 14.3411C13.4206 14.6027 13.7427 14.7957 14.0968 14.9031C14.4509 15.0105 14.826 15.0289 15.1889 14.9568C15.5518 14.8846 15.8913 14.724 16.1773 14.4893C16.4633 14.2545 16.687 13.9529 16.8286 13.6111C16.9702 13.2692 17.0253 12.8977 16.989 12.5295C16.9528 12.1613 16.8263 11.8077 16.6207 11.5C16.4152 11.1924 16.1369 10.9402 15.8106 10.7657C15.7404 10.7282 15.6684 10.6945 15.595 10.6648L16.9096 8.78673C17.0165 8.634 17.0296 8.43446 16.9435 8.26909C16.8574 8.10373 16.6864 8 16.5 8H13.5Z",
    fill: "#596169"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 19.5,
    rx: 1.75,
    stroke: "#DEE2E6",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingHeading3);
export default __webpack_public_path__ + "static/media/floating-heading3.7e7d9b6d24a61065a47854cd9e5e3a4a.svg";
export { ForwardRef as ReactComponent };